/* tslint:disable:max-line-length */
import React from 'react'

interface Props {
    width?: number
    height?: number,
    fill?: string,
    stroke?: string
}

interface State {}

export default class CheckIcon extends React.Component<Props, State> {

    public render() {

        let {
            fill = '#FFF',
            stroke = '#FFF',
            width = 8,
            height = 8
        } = this.props

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <path stroke={stroke} fill={fill} fillRule="evenodd" d="M3.727 4l-2.59-2.59a.193.193 0 1 1 .272-.274L4 3.727l2.59-2.59a.193.193 0 1 1 .274.272L4.273 4l2.59 2.59a.193.193 0 1 1-.272.274L4 4.273l-2.59 2.59a.193.193 0 1 1-.274-.272L3.727 4z"/>
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_assets/icons/Cross.tsx